$(document).ready(function(){
    var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);

    const input = document.querySelector(".intl-tel-input");
    const button = document.querySelector(".btn-tel-input-validate");
    const errorMsg = document.querySelector("#error-msg-tel-input");
    const validMsg = document.querySelector("#valid-msg-tel-input");

    // here, the index maps to the error code returned from getValidationError - see readme
    // const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
    const errorMap = [oDict["phone_invalid_number"], oDict["phone_invalid_country_code"], oDict["phone_too_short"], oDict["phone_too_long"], oDict["phone_invalid_number"]];

    if(input.dataset.country.length > 0){
        phone_plugin_country = input.dataset.country;
    }

    // initialise plugin
    const iti = window.intlTelInput(input, {
        initialCountry: phone_plugin_country,
        strictMode: true,
        nationalMode: true,
        // autoPlaceholder: "aggressive",
        autoPlaceholder: "off",
        utilsScript: "/assets/250409134714/js/plugins/intl-tel-input/utils.js?1713364227752" ,
        geoIpLookup: callback => {
            fetch("https://ipapi.co/json")
            .then(res => res.json())
            .then(data => callback(data.country_code))
            .catch(() => callback("us"));
        },
    });

    const reset = () => {
        input.classList.remove("error");
        errorMsg.innerHTML = "";
        errorMsg.classList.add("hide");
        validMsg.classList.add("hide");
    };

    const showError = (msg) => {
        input.classList.add("error");
        errorMsg.innerHTML = msg;
        errorMsg.classList.remove("hide");
    };

    window.validatePhoneNumber = function(e) {
        // If called from an event, prevent default if needed later
        if (e && e.preventDefault) {
            var hasEvent = true;
        }

        reset();
        if (!input.value.trim()) {
            // showError("Required");
            // if (hasEvent) e.preventDefault();
        } else if (iti.isValidNumber()) {
            validMsg.classList.remove("hide");
            document.querySelector('input[name="phone_national"]').value = iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
            document.querySelector('input[name="phone_dial_code"]').value = iti.getSelectedCountryData().dialCode;
            document.querySelector('input[name="phone_country_code"]').value = iti.getSelectedCountryData().iso2;
            document.querySelector('input[name="phone_e164"]').value = iti.getNumber(intlTelInputUtils.numberFormat.E164);

            var numberType = iti.getNumberType();
            var typeLabels = {
                0: "FIXED_LINE",
                1: "MOBILE",
                2: "FIXED_LINE_OR_MOBILE",
                3: "TOLL_FREE",
                4: "PREMIUM_RATE",
                5: "SHARED_COST",
                6: "VOIP",
                7: "PERSONAL_NUMBER",
                8: "PAGER",
                9: "UAN",
                10: "VOICEMAIL"
            };
            var readableType = typeLabels[numberType] || "UNKNOWN";
            document.querySelector('input[name="phone_type"]').value = readableType;

            console.log([iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL), iti.getSelectedCountryData().dialCode, iti.getSelectedCountryData().iso2, readableType]);

            return true;
        } else {
            const errorCode = iti.getValidationError();
            const msg = errorMap[errorCode] || "Invalid number";
            showError(msg);
            if (hasEvent) e.preventDefault();

            return false;
        }
    }

    // Attach the function to the button's click event
    button.addEventListener('click', window.validatePhoneNumber);

    // on keyup / change flag: reset
    input.addEventListener('change', reset);
    input.addEventListener('keyup', reset);

    function changeCountry(countryCode) {
        iti.setCountry(countryCode);
    }

    // listen to the custom event
    document.addEventListener('changePhoneCountry', function(e) {
        changeCountry(e.detail.countryCode);
    });


});
